import { MantineThemeOverride } from '@mantine/core';
import { getOverlayHeaderStyles } from 'theme/components/Overlays/overlay-header';

export type DrawerTheme = NonNullable<MantineThemeOverride['components']>['Drawer'];

export const Drawer: DrawerTheme = {
  styles: getOverlayHeaderStyles,
};
